"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { formatNumberWithCommas } from "@/helpers/Helpers";
enum VALUE_STATE {
  POSITIVE = "POSITIVE",
  NEGATIVE = "NEGATIVE",
  NEUTRAL = "NEUTRAL",
}
const CLASSES: Record<VALUE_STATE, string> = {
  [VALUE_STATE.POSITIVE]: "tw-text-green",
  [VALUE_STATE.NEGATIVE]: "tw-text-red",
  [VALUE_STATE.NEUTRAL]: "tw-text-iron-50"
};
export default function UserRateAdjustmentHelperValue(t0) {
  const $ = _c(13);
  const {
    value,
    title
  } = t0;
  const getValueState = _temp;
  const getValueString = _temp2;
  let t1;
  if ($[0] !== value) {
    t1 = getValueState(value);
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [valueState, setValueState] = useState(t1);
  const [valueString, setValueString] = useState(getValueString(value));
  let t2;
  let t3;
  if ($[2] !== value) {
    t2 = () => {
      setValueState(getValueState(value));
      setValueString(getValueString(value));
    };
    t3 = [value];
    $[2] = value;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== title) {
    t4 = <span className="tw-text-xs tw-text-iron-500 tw-font-medium">{title}</span>;
    $[5] = title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = `${CLASSES[valueState]} tw-text-xs tw-font-semibold`;
  let t6;
  if ($[7] !== t5 || $[8] !== valueString) {
    t6 = <span className={t5}>{valueString}</span>;
    $[7] = t5;
    $[8] = valueString;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <div className="tw-flex tw-items-center tw-gap-1.5 tw-px-2 tw-py-1.5 tw-bg-iron-800/50 tw-border tw-border-solid tw-border-iron-700/50 tw-rounded">{t4}{t6}</div>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}
function _temp2(n_0) {
  return n_0 > 0 ? `+${formatNumberWithCommas(n_0)}` : `${formatNumberWithCommas(n_0)}`;
}
function _temp(n) {
  if (n > 0) {
    return VALUE_STATE.POSITIVE;
  } else {
    if (n < 0) {
      return VALUE_STATE.NEGATIVE;
    } else {
      return VALUE_STATE.NEUTRAL;
    }
  }
}